/**
 *
 * UsersSelect/Modal
 *
 */

import React, { useState } from 'react'
// import PropTypes from 'prop-types'
// import styled from '@emotion/styled'

// import gql from 'graphql-tag'
// import Query from 'components/Query'
// import useQuery from 'components/UseQuery'
// import { useMutation } from '@apollo/client'

import Modal from 'components/Modal'
import UsersSelect from 'components/UsersSelect/WithData'
// import { FormattedMessage } from 'react-intl'
// import messages from './messages'

function WithModal({ onSelect, title, button, paragraph, ...props }) {
	const [modal_open, setModalOpen] = useState(false)

	const onClick = (e) => {
		e.preventDefault()
		setModalOpen(true)
	}

	const default_button = (
		<button
			type="button"
			className="btn btn-primary mr-3"
			onClick={onClick}
		>
			Select User
		</button>
	)

	if (button){
		button = React.cloneElement(
			button, 
			{
				onClick,
				...button.props,
			},
		)
	}


	return (
		<React.Fragment>
			{button || default_button}
			<Modal show={modal_open} modalDidClose={() => setModalOpen(false)}>
				<h3>{title}</h3>
				{paragraph && <p>{paragraph}</p>}
				<UsersSelect
					onSelect={(user) => {
						onSelect(user)
						setModalOpen(false)
					}}
					{...props}
				/>
			</Modal>
		</React.Fragment>
	)
}

WithModal.propTypes = {}

WithModal.defaultProps = {
	onSelect: () => null,
}

export default WithModal
